module.exports = __webpack_public_path__ + "img/hospital.1def400c.svg";